import ClearingAPI from '@shared/api';

export const {
    lookups: { get: getLookups },
} = ClearingAPI.settings;
